import { generate } from '../utils/a15componentUtils';
import { isDeviceTypeLargerThan, DEVICE_CHARACTERISTICS_SIZE } from '../utils/generalUtils';
import { changeProductTileAltImg } from '../utils/eventUtils';

export function attachEvents(store) {
    const isTouchDevice = _.get(this.getDeviceCharacteristics(), 'is_touch', false);
    const jsClassSelector = '.js-product-tile-controls__link-wrap';
    const jsQsClassSelector = 'js-product-tile-control-quickshop';
    const jsFavoriteClassSelector = 'js-favorite-toggle';
    const tileControlsSelector = '.c-product-tile-controls';
    const tileControlsHoverClass = 'c-product-tile-controls--hover';
    const heartSelector = '.c-product-heart';
    const heartHoverClass = 'c-product-heart--hover';

    if(!isTouchDevice) {
        const addTileClasses = function fn(target) {
            $(target).children(tileControlsSelector)
                     .addClass(tileControlsHoverClass);
            $(target).find(heartSelector)
                     .addClass(heartHoverClass);
        };

        const removeTileClasses = function fn() {
            $(tileControlsSelector).removeClass(tileControlsHoverClass);
            $(heartSelector).removeClass(heartHoverClass);
        };

        $(document).on({
            mouseenter: function fn(e) {
                addTileClasses(e.currentTarget);
            },
            mouseleave: function fn() {
                removeTileClasses();
            },
            focus: function fn(e) {
                addTileClasses(e.currentTarget);
                changeProductTileAltImg(e, null);
            },
            blur: function fn(e) {
                const relatedTargetClassList = _.get(e, 'relatedTarget.classList');
                const targetNeedsFocus = relatedTargetClassList &&
                (relatedTargetClassList.contains(jsQsClassSelector) ||
                relatedTargetClassList.contains(jsFavoriteClassSelector));

                // maintain focus state for QS and Favorite selectors
                if (!targetNeedsFocus) {
                    removeTileClasses();
                    changeProductTileAltImg(e, null);
                }
            }
        }, jsClassSelector);

    } else if (isDeviceTypeLargerThan(store.getState(), DEVICE_CHARACTERISTICS_SIZE.SMALL)) {

        $(jsClassSelector).children(tileControlsSelector).addClass(tileControlsHoverClass);
        $(jsClassSelector).find(heartSelector).addClass(heartHoverClass);

    }
}

export function init(store, overrides = {}) {
    const config = {
        name: 'productTileComponent',
        attachEvents
    };

    return generate(config, store, overrides);
}
